module.exports = __webpack_public_path__ + "img/9.48369312.jpg";